import { saveAs } from 'file-saver';
import { getAttachment, getAttachmentName } from '@/shared/helpers/api';
import { http } from '@/shared/httpWrapper';

export async function downloadFile(key: string): Promise<void> {
    const [blob, fileName] = await Promise.all([
        getAttachment(http, key),
        getAttachmentName(http, key)
    ]);
    if (blob) {
        saveAs(blob, fileName);
    }
}
